/**
 * @generated SignedSource<<55d2893062634fb82331e5a37e311b90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookingConfirmedModalShareSection_Booking$data = {
  readonly id: string;
  readonly shareUrl: string | null | undefined;
  readonly " $fragmentType": "BookingConfirmedModalShareSection_Booking";
};
export type BookingConfirmedModalShareSection_Booking$key = {
  readonly " $data"?: BookingConfirmedModalShareSection_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingConfirmedModalShareSection_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingConfirmedModalShareSection_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shareUrl",
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "b6db44dfc5a34da6e440def2a6ea4997";

export default node;
